import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Compact native select (28px), styled by .ac-select in account.css. `options` is a list of [value, label].
export function CompactSelect({ id, name, value, onChange, options, style, label }) {
  return (
    <div className="ac-select" style={style}>
      <select id={id} name={name} value={value} onChange={onChange} aria-label={label}>
        {options.map(([v, label]) => (
          <option key={v} value={v}>
            {label}
          </option>
        ))}
      </select>
      <ExpandMoreIcon />
    </div>
  );
}

// Copy to the clipboard, then confirm with the app's success toast.
export function copyText(text, message) {
  if (!navigator.clipboard) return;
  navigator.clipboard.writeText(text).then(() => {
    if (message) window.dispatchEvent(new CustomEvent("app-success", { detail: message }));
  });
}
